export default {
  title: "Vous n'avez pas trouvé ce que vous cherchiez ? Nous le concevons pour vous !",
  subTitle:
    "Si vous avez besoin d'une illustration scientifique qui n'est pas encore disponible dans notre galerie, vous pouvez la demander et nous la concevrons pour vous. Suivez les étapes ci-dessous :",
  stepOne:
    "Accédez à l'espace de travail et cliquez sur le bouton Demander une Bouton 'Illustration', à l'adresse en bas à gauche de votre écran.",
  stepTwo:
    'Remplir le formulaire avec le des détails sur les illustration scientifique vous besoin. Vous pouvez également joindre références, comme la main les dessins et autre images.',
  stepThree:
    'Votre demande doit comporter environ 7 jours ouvrables pour être prêt. Vous recevrez des na email lorsque les scientifiques est disponible.',
  text: 'Vous pouvez également demander une illustration en cliquant sur le bouton ci-dessous.',
  textButton: 'Demander une illustration Maintenant',
};
